import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MarketingLayout } from '@byscott-io/corebyscott';
import { portalApi } from '../../api/portal';

// Affiliate application (#612), in marketing chrome. Creates a PENDING affiliate;
// they can't sign in until a maintainer approves and we email them.
export default function SignupPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await portalApi.signup(name, email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Something went wrong — please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MarketingLayout>
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="bg-white rounded-lg shadow p-8">
          <h1 className="text-2xl font-bold mb-1">Apply to become an affiliate</h1>
          <p className="text-gray-500 mb-6">
            Free to join, no quotas. We review every application by hand.
          </p>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4 text-sm">
              {error}
            </div>
          )}

          {sent ? (
            <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded">
              Thanks for applying! We&apos;ll review your application and email you a
              sign-in link once you&apos;re approved.
            </div>
          ) : (
            <form onSubmit={submit}>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4"
                placeholder="Jane Smith"
              />
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4"
                placeholder="you@example.com"
              />
              <button
                type="submit"
                disabled={submitting || !name || !email}
                className="w-full bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 disabled:opacity-50"
              >
                {submitting ? 'Submitting…' : 'Apply to become an affiliate'}
              </button>
            </form>
          )}

          <p className="mt-6 text-center text-sm text-gray-500">
            Already an affiliate?{' '}
            <Link to="/login" className="text-indigo-600 hover:text-indigo-800">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </MarketingLayout>
  );
}
